/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { NetCloudCheckIcon16Light } from './NetCloudCheckIcon16Light';
import { NetCloudCheckIcon16Regular } from './NetCloudCheckIcon16Regular';
import { NetCloudCheckIcon16Solid } from './NetCloudCheckIcon16Solid';
import { NetCloudCheckIcon20Light } from './NetCloudCheckIcon20Light';
import { NetCloudCheckIcon20Regular } from './NetCloudCheckIcon20Regular';
import { NetCloudCheckIcon20Solid } from './NetCloudCheckIcon20Solid';
import { NetCloudCheckIcon24Regular } from './NetCloudCheckIcon24Regular';
import { NetCloudCheckIcon24Solid } from './NetCloudCheckIcon24Solid';
import { NetCloudCheckIcon32Regular } from './NetCloudCheckIcon32Regular';
import { NetCloudCheckIcon64Regular } from './NetCloudCheckIcon64Regular';
var sizes = {
    16: {
        light: NetCloudCheckIcon16Light,
        regular: NetCloudCheckIcon16Regular,
        solid: NetCloudCheckIcon16Solid,
    },
    20: {
        light: NetCloudCheckIcon20Light,
        regular: NetCloudCheckIcon20Regular,
        solid: NetCloudCheckIcon20Solid,
    },
    24: {
        regular: NetCloudCheckIcon24Regular,
        solid: NetCloudCheckIcon24Solid,
    },
    32: {
        regular: NetCloudCheckIcon32Regular,
    },
    64: {
        regular: NetCloudCheckIcon64Regular,
    },
};
export var NetCloudCheckIcon = forwardRef('NetCloudCheckIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
